
export default {
  name: 'GcHorizontalLayout',
  data() {
    return {
      className: 'gc__horizontal-layout',
    };
  },
  computed: {
    leftSideClassName() {
      return `${this.className}__left-side`;
    },
    rightSideClassName() {
      return `${this.className}__right-side`;
    },
    reverseRowClassName() {
      return this.reverseRow ? `${this.className}--reverse` : '';
    },
    alignItemsCenter() {
      return this.$slots.content ? '' : `${this.className}--align-center`;
    },
  },
  props: {
    reverseRow: {
      type: Boolean,
      default: false,
    },
  },
};
